var ActivityStatusFilter = require("../ActivityList/activity-status-filter");
var UserSelectFilter = require("../ActivityList/user-select-filter");
var ViewTypeFilter = require("../ActivityList/view-type-filter");
var ButtonGroup = require("app/shared/components/ButtonGroup/button-group");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");

var CalendarToolbar = React.createClass({
  propTypes: {
    availableViews: React.PropTypes.array
  },

  getInitialState: function() {
    return({ viewName: this.props.view });
  },

  componentWillMount: function() {
    this.filters = { pending: true };
    CUI.filters.userId = window.loggedUserId;
  },

  setFilter: function(filter, value, _wait) {
    if (this.filters[filter] === value) return;

    this.filters[filter] = value;
    CUI.filters[filter] = value;

    // Only allow editing when displaying pending events.
    if (filter === "pending") this.props.toggleEditing(this.filters.pending);

    this.props.reloadActivities();
  },

  changeView: function(viewName) {
    this.setState({ viewName: viewName });
    this.props.changeView(viewName);
  },

  render: function() {
    return (
      <div className="bootstrap-agendor tasks-filter mb20">
        <div className="task-header u-flex-center jc-sb p-15 bg-primaryGray">
          <div>
            <ButtonGroup>
              {this.props.availableViews.map(view =>
                <Button
                  key={view.name}
                  type="filter"
                  className={this.state.viewName === view.name ? "selected" : ""}
                  onClick={() => this.changeView(view.name)}
                >
                  {view.label}
                </Button>
              )}
            </ButtonGroup>

            <Button
              type="link"
              className="ml-20 mr-20"
              onClick={() => this.props.navigateView("today")}
            >
              Hoje
            </Button>

            <Button
              type="filter"
              className="btn-icon active mr-5"
              onClick={() => this.props.navigateView("prev")}
            >
              <Icon custom icon="chevron-left" />
            </Button>
            <Button
              type="filter"
              className="btn-icon active"
              onClick={() => this.props.navigateView("next")}
            >
              <Icon custom icon="chevron-right" />
            </Button>
          </div>

          <div className="flex-1 text-center">
            <ActivityStatusFilter setFilter={this.setFilter} filters={this.filters} />
          </div>

          <div className="mr-10">
            <UserSelectFilter setFilter={this.setFilter} filters={this.filters} showLabel={false} />
          </div>
          <ViewTypeFilter selected="calendar" />
        </div>
      </div>
    );
  }
});

module.exports = CalendarToolbar;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/Calendar/calendar-toolbar.jsx